'use client'

import React from 'react'
import Image from 'next/image'
import { RIGHT_ARROW_BLUE_URL } from '@constants/contactUs.constants'
import { trackEvent } from '@acko-tech/building-blocks.ui.acko-analytics'
import { getDevicePlatform } from '@utils/segmentProperties'
import { eventConfig } from '@configs/contactus.config'
import styles from './styles.module.scss'

const CommsCard = ({ data, onCtaClick }) => {
  const { tag, title, description, cta, Modal } = data.attributes
  const handleClick = async () => {
    onCtaClick(Modal)
    const ctaType = cta.Type
    const event = eventConfig[ctaType]

    if (event) {
      await trackEvent(event.eventName, {
        ...event.eventProps,
        platform: getDevicePlatform(),
      })
    }
  }

  return (
    // eslint-disable-next-line @typescript-eslint/no-misused-promises
    <div className={styles.card} onClick={handleClick}>
      <div className={`${styles.tag} ${styles[`tag--${tag.colorScheme}`]}`}>{tag.text}</div>
      <h3 className={styles.title}>{title}</h3>
      <p className={styles.description}>
        {description?.split(',').map((part, idx) => (
          <React.Fragment key={idx}>
            {part.trim()}
            {idx < description.split(',').length - 1 && <br />}
          </React.Fragment>
        ))}
      </p>
      <span className={styles.cta}>
        {cta.Title}
        {cta.Arrow && <Image src={RIGHT_ARROW_BLUE_URL} alt="right-arrow" width={20} height={20} />}
      </span>
    </div>
  )
}

export default CommsCard
